export default "__VITE_ASSET__Cs_uIDd3__"